import { render, staticRenderFns } from "./kcSelect.vue?vue&type=template&id=67973ce0&scoped=true&"
import script from "./kcSelect.vue?vue&type=script&lang=js&"
export * from "./kcSelect.vue?vue&type=script&lang=js&"
import style0 from "./kcSelect.vue?vue&type=style&index=0&id=67973ce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67973ce0",
  null
  
)

export default component.exports